import React from "react";

import { ResponseType, OptionsType } from "commons/types/http";

import useHttpManaged from "hooks/useHttpManaged";

import { PathParamsWithId, ResponseWithId } from "commons/types/api/common";

import { NewsImageBody } from "types/api/newsImage";

function useNewsImageApi() {
    const { del, post, put } = useHttpManaged();
    const createNewsImage = React.useCallback((body: NewsImageBody, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<ResponseWithId> => {
        return post<undefined, undefined, NewsImageBody, ResponseWithId>({
            url: "/news-image",
            body: body,
            options: options,
            headers: headers
        });
    }, [post]);
    const updateNewsImage = React.useCallback((pathParams: PathParamsWithId, body: NewsImageBody, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<null> => {
        return put<PathParamsWithId, undefined, NewsImageBody, null>({
            url: "/news-image/:id",
            pathParams: pathParams,
            body: body,
            options: options,
            headers: headers
        });
    }, [put]);
    const deleteNewsImage = React.useCallback((pathParams: PathParamsWithId, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<null> => {
        return del<PathParamsWithId, undefined, null>({
            url: "/news-image/:id",
            pathParams: pathParams,
            options: options,
            headers: headers
        });
    }, [del]);
    return {
        createNewsImage,
        updateNewsImage,
        deleteNewsImage
    };
}

export default useNewsImageApi;